/* unplugin-vue-components disabled */import script from "./TtgConvert.vue?vue&type=script&setup=true&lang=js"
export * from "./TtgConvert.vue?vue&type=script&setup=true&lang=js"

import "./TtgConvert.vue?vue&type=style&index=0&id=274954de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274954de"]])

export default __exports__